<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue-mckenna-goes-home">
<h1>Prologue <br/> McKenna Goes Home</h1>
<p><em>I once read that time is not a real healer. The passage of time may take the edge off pain, but it does not heal the pain; only medicine can do that, or so my family insists</em>, thought McKenna as she looked upon the golden sunset, deep in reflection.</p>
<p><em>Papa said that hurt will pass and the scars will eventually heal as time continues on. Papa told me he had no choice but to let go of his pain after Mother died. He said he could either suffer each day and let his hurt affect his practice, or he could let go of his pent-up pain and anger and dismiss the anguish in his life. I often wonder if he avoided his pain by pretending it wasn’t there. Or, did he put on a good front for the sake of others? For the sake of me?</em></p>
<p><em>Uncle Pepper told me that people mask their pain by circumventing it. He told me that he had learned to avoid any painful situation by looking the other way. How in the world did he circumvent his own father?</em></p>
<p><em>Will time heal the wounds to the hearts of widows and fatherless children from the war? Will the scars of battle fade away on the cities and landscapes that were destroyed and decimated? How much time will be needed before I can go home to Charleston? How will South Carolina or any other state heal from the horrors of those four years, or for that matter, the entire country?</em></p>
<p><em>Will my family forever be thought of as rebels? Will the Johnny Rebs, the butternuts, and the graybacks always be looking over their shoulders? Will they circle around their campfires, sharing goober peas while singing the distant melody of ‘The Bonnie Blue Flag’? How long will it take this country to heal? How much time will pass for all wounds to heal? When will kindness and good replace intolerance and animosity? When will folks disregard my southern accent and appreciate me as I am? Will I always face the unfair contempt?</em></p>
<p><em>Maybe it is time for me to go back home to Charleston, or whatever remains of my home. Is Papa right? Will the scars eventually heal?</em></p>
<p><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?1d9e3791